export const PICKUP_DELIVERY_ID = 5;
export const COURIER_DELIVERY_ID = 1;
export const EXPRESS_DELIVERY_INTERVAL_ID = 4;

export const EXPRESS_DELIVERY_STORAGE_KEY = 'isSelectExpressDel';
export const PRICE_CHANGE_WARNING_STORAGE_KEY = 'hideAddressModalNotice';

/** Typed wrapper around the express-delivery localStorage flag. */
export const expressDeliveryStorage = {
  get(): boolean {
    try {
      return !!JSON.parse(
        localStorage.getItem(EXPRESS_DELIVERY_STORAGE_KEY) || 'false'
      );
    } catch {
      return false;
    }
  },
  set(value: boolean): void {
    // Persisted as 'true' / 'false' (matches the historical string values).
    localStorage.setItem(EXPRESS_DELIVERY_STORAGE_KEY, String(value));
  }
};
